import styled from 'styled-components';

const AboutContent = styled.div`
  padding: 0 5rem;
  min-height: 90vh;
  @media (max-width: 37.5rem) {
    padding: 0 2rem;
  }

  span {
    white-space: nowrap;
  }
`;

export {
  AboutContent,
};